import DefaultDemandNote from "src/components/feature/DemandNote";

const DemandNote = () => {
  return <DefaultDemandNote />;
};

export default DemandNote;
